import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterLimitesAsync,
    enviarLimiteAsync,
    editarLimiteAsync,
    downloadLista,
    enviarLimitesAsync
}

export const obterLimitesAsync = async() => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Limite/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterUsuariosAsync = async() => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Limite/obterUsuarios`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarLimiteAsync = async(idUsuario, valorLimite) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ idUsuario, valorLimite })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Limite`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}
export const enviarLimitesAsync = async(limites) => {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ limites })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Limite/enviar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarLimiteAsync = async(id, idUsuario, valorLimite) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, idUsuario, valorLimite })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Limite/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}
export const excluirLimiteAsync = async(id, idUsuario, valorLimite) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, idUsuario, valorLimite })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Limite/excluir`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}


export function downloadLista() {
    try {
        return axios({
                url: `${process.env.VUE_APP_ROOT_API}/Limite/downloadLimites`,
                method: 'GET',
                responseType: 'blob',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
            }).catch(() => {
                return { status: false };
            })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'limites' + '.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}